import { groupSettingsSelectors, mmsApiActions } from '@lifesize/nucleus';
import Icon from 'components/Common/Icon';
import CopyToClipboard from 'components/CopyToClipboardButton/CopyToClipboardButton';
import _get from 'lodash/get';
import React from 'react';
import intl from 'react-intl-universal';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { Button } from 'semantic-ui-react';
import { actions } from '../../../actions/modalActions';
import { Global } from '../../../state/Global';
import { withOutsideClickDetection } from '../../../utils/hocs/withOutsideClickDetection';
import Modal from '../../Modal/ModalComponent/ModalComponent';
import { Tooltip } from '../../tooltip/Tooltip';
import * as styles from './InviteUserModal.scss';

interface Props {
  closeModal: () => void;
  getInvitationLink: (isRenew: boolean) => void;
  invitationToken: string;
  emailBody: string;
  subject: string;
}

class InviteUserModal extends React.PureComponent<Props> {
  componentDidMount() {
    if (!this.props.invitationToken) {
      this.props.getInvitationLink(false);
    }
  }

  render() {
    const { closeModal, getInvitationLink, invitationToken, emailBody, subject } = this.props;

    return (
      <Modal
        titleText={intl.get('inviteUser')}
        closeModal={closeModal}
        closeText={intl.get('cancel')}
      >
        <div className={styles.container}>
          <div className={styles.subTitle}>{intl.get('inviteUserSubtitle')}</div>
          <Button
            className={styles.btnSendInvite}
            disabled={!invitationToken}
            name="btnSendInvite"
            onClick={
              () => {
                window.open(
                  `mailto: ?subject=${subject}&body=${emailBody}`,
                  '_self'
                );
                closeModal();
              }
            }
            role="button"
            type="button"
          >
            {intl.get('sendInvitation')}
          </Button>
          <div className={styles.line}/>
          <div className={styles.cta}>{intl.get('inviteUsersCTA')}</div>
          <div className={styles.inviteLinkContainer}>
            <div className={styles.inviteLink}>
              <span>{(!invitationToken) ? '....' : invitationToken}</span>
            </div>
            <div className={styles.buttonContainer}>
              <Tooltip text={intl.get('copyToClipboard')}>
                <CopyToClipboard text={invitationToken} className={styles.buttonCopy} />
              </Tooltip>
              <Tooltip text={intl.get('refreshInvitation')}>
                <button onClick={() => getInvitationLink(true)} className={styles.button} name="btnRefresh" role="button" type="button">
                  <Icon classes={['icon-loader']}/>
                </button>
              </Tooltip>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state: Global) => {
  const groupSettings = groupSettingsSelectors.groupSettings(state) || {};
  const groupSettingsLocale = _get(groupSettings, 'locale');
  const token = _get(state.nucleus, 'account.token', '');
  let invitationToken = (token) ? process.env.REACT_APP_WELCOME_URL : '';
  if (!!groupSettingsLocale) {
    invitationToken += (token)  ? `/${token}?lang=${groupSettingsLocale}` : '';
  } else {
    invitationToken += (token)  ? `/${token}` : '';
  }
  const emailBody = encodeURIComponent(
    `${intl.get('inviteBody1')}\n\n${invitationToken}\n\n${intl.get('inviteBody2')}\n\n${intl.get('inviteBody3')} https://www.lifesize.com/app-help\n\n${intl.get('inviteBody4')}`
  );
  const subject = encodeURIComponent(intl.get('inviteSubject'));
  return {
    emailBody,
    subject,
    invitationToken,
  };
};

const mapDispatchToProps = (dispatch: Function) => ({
  closeModal: () => {
    dispatch(actions.closeModal());
  },
  getInvitationLink: (isRenew: boolean) => {
    dispatch(mmsApiActions.getInvitationLink(isRenew));
  }
});

const composed = compose<Props, Props>(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
      onKeyPress: (props: Props) => (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
          props.closeModal();
        }
      },
    }),
  withOutsideClickDetection
)(InviteUserModal);

export default composed;
